import { ru } from 'locale';

const options = [
  { label: ru.agreed, value: 'agreed' },
  { label: ru.notAgreed, value: 'notAgreed' },
  { label: ru.noDecision, value: 'noDecision' },
];

export default options;
